import {NbDialogRef} from '@nebular/theme';
import {NavigationExtras, Router} from '@angular/router';
import {Directive, Input} from '@angular/core';
@Directive()
export class BaseDialog<T> {
  redirect: string;
  queryParams: NavigationExtras;

  @Input()
  title: string;

    constructor(protected dialogRef: NbDialogRef<T>, private route: Router) {
  }

  close(result?) {
    this.dialogRef.close(result);

    if (this.redirect) {
      this.route.navigate([this.redirect], this.queryParams);
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
